<template>
<div class="data-list">

  <div v-if="searchable">
    <div class="flexrow search-options">
      <search-field
        ref="people-search-field"
        class="search flexrow-item"
        :can-save="true"
        @change="onSearchChange"
        @enter="saveSearchQuery"
        @save="saveSearchQuery"
        placeholder="ex: John Doe"
      />
      <checkbox
        class="client-toggle flexrow-item"
        label="Show Clients"
        :toggle=true
        v-model="show_clients"
      />
      <!-- <button-simple
        class="flexrow-item filter-button"
        :title="$t('entities.build_filter.title')"
        icon="funnel"
        @click="() => modals.isBuildFilterDisplayed = true"
      /> -->
    </div>

    <!-- <div class="query-list">
      <search-query-list
        :queries="peopleSearchQueries"
        @change-search="changeSearch"
        @remove-search="removeSearchQuery"
      />
    </div> -->
  </div>

  <div class="datatable-wrapper">
    <table class="datatable">
      <thead class="datatable-head">
        <tr style="background: inherit;">
          <th scope="col" class="check" @click="onHeaderClick('selected')">
            x
          </th>
          <th scope="col" class="name datatable-row-header" @click="onHeaderClick('name')">
            {{ $t("people.list.name") }}
          </th>
          <th scope="col" class="role" @click="onHeaderClick('role')">
            {{ $t("people.list.role") }}
          </th>
          <th scope="col" class="email" @click="onHeaderClick('email')">
            {{ $t("people.list.email") }}
          </th>
          <th scope="col" class="position" @click="onHeaderClick('position')">
            {{ $t("people.fields.position") }}
          </th>
          <th scope="col" class="company" @click="onHeaderClick('company')">
            {{ $t("people.fields.company") }}
          </th>
          <th scope="col" class="phone" @click="onHeaderClick('phone')">
            {{ $t("people.list.phone") }}
          </th>
          <th scope="col" class="phone_mobile" @click="onHeaderClick('phone_mobile')">
            {{ $t("people.fields.phone_mobile") }}
          </th>
          <!-- <th scope="col" class="phone2" @click="onHeaderClick('phone2')">
            {{ $t("people.list.phone") + ' 2' }}
          </th>
          <th scope="col" class="phone3" @click="onHeaderClick('phone3')">
            {{ $t("people.list.phone") + ' 3' }}
          </th>
          <th scope="col" class="phone_mobile2" @click="onHeaderClick('phone_mobile2')">
            {{ $t("people.fields.phone_mobile") + ' 2' }}
          </th>
          <th scope="col" class="fax" @click="onHeaderClick('fax')">
            {{ $t("people.fields.fax") }}
          </th> -->
          <th scope="col" class="street" @click="onHeaderClick('street')">
            {{ $t("people.fields.street") }}
          </th>
          <th scope="col" class="plz" @click="onHeaderClick('plz')">
            {{ $t("people.fields.plz") }}
          </th>
          <th scope="col" class="city" @click="onHeaderClick('city')">
            {{ $t("people.fields.city") }}
          </th>
          <th scope="col" class="country" @click="onHeaderClick('country')">
            {{ $t("people.fields.country") }}
          </th>
          <th scope="col" class="website" @click="onHeaderClick('website')">
            {{ $t("people.fields.website") }}
          </th>
          <th scope="col" class="blog" @click="onHeaderClick('blog')">
            {{ $t("people.fields.blog") }}
          </th>
          <th scope="col" class="birthday" @click="onHeaderClick('birthday')">
            {{ $t("people.fields.birthday") }}
          </th>
          <th scope="col" class="languages" @click="onHeaderClick('languages')">
            {{ $t("people.fields.languages") }}
          </th>
        </tr>
      </thead>
      <tbody class="datatable-body" v-if="!isEmpty">
        <tr
          class="datatable-row"
          v-for="entry in filteredPeople"
          :key="entry.id"
        >
          <!-- <people-name-cell class="name" :person="entry" /> -->
          <td class="check">
            <checkbox
              class="checkbox"
              label=""
              :toggle="false"
              :disabled="disabled"
              :checked="isPersonSelected(entry.id)"
              @change="(checked) => {
                if (checked) {
                  $emit('select', entry.id)
                } else {
                  $emit('remove', entry.id)
                }
              }"
            />
          </td>
          <td class="name">
            <router-link
              :to="{
                name: 'person',
                params: {
                  person_id: entry.id
                }
              }"
              :title="entry.full_name"
              class="name-link"
            >
              {{ entry.name }}
            </router-link>
          </td>
          <td class="role">{{ $t('people.role.' + entry.role) }}</td>
          <td class="email">{{ entry.email }}</td>
          <!-- <td class="phone">{{ entry.phone }}</td> -->
          <!-- <td class="phone2">{{ entry.phone2 }}</td>
          <td class="phone3">{{ entry.phone3 }}</td>
          <td class="phone_mobile2">{{ entry.phone_mobile2 }}</td>
          <td class="fax">{{ entry.fax }}</td> -->
          <td class="position">{{ entry.position }}</td>
          <td class="company">{{ entry.company }}</td>
          <td class="phone"> {{ entry.tel || entry.tel2 || entry.tel3 }} </td>
          <td class="phone_mobile">{{ entry.phone_mobile || entry.phone_mobile2 }}</td>
          <td class="street">{{ entry.street }}</td>
          <td class="plz">{{ entry.plz }}</td>
          <td class="city">{{ entry.city }}</td>
          <td class="country">{{ entry.country }}</td>
          <td class="website">{{ entry.website }}</td>
          <td class="blog">{{ entry.blog }}</td>
          <td class="birthday">{{ formatedBirthday(entry) }}</td>
          <td class="languages">{{ entry.languages }}</td>
          <!-- <td class="actions"
            v-if="isCurrentUserAdmin && !disableRemove"
          >
            <button
              class="button"
              @click="removePerson(entry)"
            >
              {{ $t('main.remove') }}
            </button>
          </td>
          <td class="actions" v-else>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>

  <p class="has-text-centered mt2" v-if="isEmpty">
    {{ $t('people.empty_team') }}
  </p>

  <!-- <p class="has-text-centered footer-info">
    {{ people.length }} {{ $t('people.title') }} - {{ selected.length }} {{ $t('main.selected') }}
  </p> -->
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { formatDateSimple } from '@/lib/time'
import { sortPeopleBy } from '@/lib/sorting'

import Checkbox from '@/components/widgets/Checkbox'
// import ButtonSimple from '@/components/widgets/ButtonSimple'
import SearchField from '@/components/widgets/SearchField'
import SearchQueryList from '@/components/widgets/SearchQueryList'

export default {
  name: 'people-checklist',

  components: {
    Checkbox,
    // ButtonSimple,
    SearchField,
    SearchQueryList
  },

  data() {
    return {
      sort_key: 'name',
      sort_dir: 1,
      show_clients: false,
    }
  },

  props: {
    people: {
      default: () => [],
      type: Array
    },
    selected: {
      default: () => [],
      type: Array
    },
    disabled: {
      default: false,
      type: Boolean
    },
    searchable: {
      default: true,
      type: Boolean
    }
  },

  computed: {
    ...mapGetters([
      'displayedPeople',
      'peopleSearchQueries'
    ]),

    sortedPeople () {
      if (this.sort_key === 'selected') {
        return [ ...this.people ].sort((a, b) => {
          const a_sel = this.isPersonSelected(a.id)
          const b_sel = this.isPersonSelected(b.id)
          if (a_sel && !b_sel) {
            return -(this.sort_dir)
          } else if (b_sel && !a_sel) {
            return this.sort_dir
          } else {
            return a.role ? a.role.localeCompare(b.role) : this.sort_dir
          }
        })
      } else {
        return sortPeopleBy([ ...this.people ], this.sort_key, this.sort_dir)
      }
    },

    filteredPeople () {
      return this.sortedPeople.filter(x => {
        return this.show_clients ? x.role === 'client' : x.role !== 'client' && x.active
      })
    },

    isEmpty () {
      return !this.people || this.people.length === 0 
    },

    searchField () {
      return this.$refs['people-search-field']
    }
  },

  methods: {
    ...mapActions([
      'setPeopleSearch',
      'savePeopleSearch'
    ]),

    onHeaderClick (key) {
      if (this.sort_key === key) {
        this.sort_dir = this.sort_dir < 0 ? 1 : -1
      } else {
        this.sort_key = key
        this.sort_dir = 1
      }
    },

    formatedBirthday (person) {
      return formatDateSimple(person.birthday, 'DD.MM.YYYY')
    },

    isPersonSelected (personId) {
      const res = this.selected.find((pers) => {
        return pers.id === personId
      })
      if (res === undefined) {
        return false
      } else {
        return true
      }
    },

    onSearchChange () {
      if (!this.searchField) return
      const searchQuery = this.searchField.getValue()
      if (searchQuery.length !== 1) {
        this.setPeopleSearch(searchQuery)
      }
    },

    saveSearchQuery (searchQuery) {
      this.savePeopleSearch(searchQuery)
        .catch(console.error)
    }
  }
}
</script>

<style lang="scss" scoped>
.datatable-body tr:first-child th,
.datatable-body tr:first-child td {
  border-top: 0;
}
td {
  font-weight: normal;
  color: var(--text);
  text-wrap: nowrap;
}
thead {
  background: var(--background);
}
.name {
  width: 230px;
  min-width: 230px;
  border-right: 1px solid var(--border);
  font-weight: bold;
  color: var(--text);
  background-color: inherit;
  position: sticky;
  left: 0;
}
.email {
  width: 300px;
  min-width: 300px;
}
.phone {
  width: 200px;
  min-width: 200px;
}
.check {
  width: 30px;
  min-width: 30px;
  max-width: 30px;
  padding-bottom: 0;
}
.role {
  width: 250px;
  min-width: 250px;
}
.actions {
  min-width: 100px;
}

.data-list {
  margin-top: 2em;
}

tr {
  line-height: 0;
}
.checkbox {
  margin-bottom: 14px;
  margin-top: 6px;
}
.search-options {
  margin-bottom: 20px;
}

th, td {
  min-width: 200px;
}
</style>
